import { useDispatch } from "react-redux";
import {
    authorpostsearched,
    categorysearched,
} from "../../redux/filters/actions";

const BlogCard = ({ item }) => {
    const dispatch = useDispatch();

    const catHandler = (data) => {
        dispatch(categorysearched(data));
    };

    const authorHandler = (data) => {
        dispatch(authorpostsearched(data));
    };

    return (
        <>
            <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
                <div className="flex-shrink-0">
                    <img
                        className="h-48 w-full object-cover"
                        src={item.image}
                        alt=""
                    />
                </div>

                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                    <div className="flex-1">
                        <p
                            onClick={() => catHandler(item.category)}
                            className="text-sm font-medium text-indigo-600"
                        >
                            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                                {item.category}
                            </span>
                        </p>
                        <a href="#" className="block mt-1">
                            <p className="text-xl font-semibold text-gray-900">
                                {item.title}
                            </p>
                        </a>
                    </div>
                    <div className="mt-6 flex items-center">
                        <div className="flex-shrink-0">
                            <img
                                className="h-10 w-10 rounded-full object-cover"
                                src={item.author.profileImage}
                                alt=""
                            />
                        </div>
                        <div className="ml-3">
                            <p
                                onClick={() => authorHandler(item.author.name)}
                                className="text-sm font-medium text-gray-900 hover:underline"
                            >
                                {item.author.name}
                            </p>
                            <div className="flex space-x-1 text-sm text-gray-500">
                                {/* <time datetime="2020-03-16">
                                                        11 Jul, 2022
                                                    </time>
                                                    <span aria-hidden="true">
                                                        ·
                                                    </span> */}
                                <span>{item.date}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogCard;
